
/**
 * Konfig pre vlajky
 */
export const flagsConfig = {

  // horizontalna hodnota posunu pre offset
  horizontalValue: 0.125,

  // vertikalna hodnota posunu pre offset
  verticalValue: 0.083007,

  // rychlost akou sa vlni lightmapa
  lightMapSpeed: 0.005,

  // rychlost aktualizacie vlajok (bude sa to delit este fps limitom)
  updateSpeed: 4,

  // rychlost rotacie vlajok
  rotationSpeed: 0.002,

  // moznost zmeny rotacie pocast rotovania
  rotationChangeProbability: 0.8,

  // minimalna rotacia
  rotationMin: -0.2,

  // maximalna rotacia
  rotationMax: 0.2,

  // ake vlajky sa pouziju
  flagsToUse: [
    // Australia
    {
      x: 0,
      y: 1
    },
    // China
    {
      x: 2,
      y: 0
    },
    // Czech republic
    {
      x: 2,
      y: 4
    },
    // Finland
    {
      x: 3,
      y: 1
    },
    // France
    {
      x: 3,
      y: 0
    },
    // Germany
    {
      x: 5,
      y: 0
    },
    // Great Britain
    {
      x: 1,
      y: 0
    },
    // Hungary
    {
      x: 6,
      y: 0
    },
    // Italy
    {
      x: 4,
      y: 0
    },
    // Slovakia
    {
      x: 7,
      y: 4
    },
    // Spain
    {
      x: 6,
      y: 2
    },
    // United States
    {
      x: 0,
      y: 0
    },
  ]

}